import { DeliveryPreferenceType } from '@order/graphql';

export const DELIVERY_PREFERENCE = {
  LEAVE_AT_DOOR: DeliveryPreferenceType.LeaveAtDoor,
  DOOR: DeliveryPreferenceType.Door,
  CURBSIDE: DeliveryPreferenceType.Curbside,
};

export const defaultAddressForm = {
  addressType: 'home',
  name: '',
  street: '',
  secondaryStreet: '',
  city: '',
  zipCode: '',
  state: '',
  country: '',
  googlePlaceId: '',
  latitude: 0,
  longitude: 0,
  notes: '',
  deliveryPreference: DeliveryPreferenceType.LeaveAtDoor,
};
